import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag, LogOut } from "lucide-react";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";

const LOGO = "https://customer-assets-cm19k8pv.emergentagent.net/job_naija-eats-6/artifacts/gjad5l4b_ChopBoxCo%20Green%20Logo%20PNG.png";

export default function Header() {
  const { count, setIsOpen } = useCart();
  const { user, login, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 w-full backdrop-blur-xl bg-[#FDFBF7]/80 border-b border-[#1A6B2E]/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3">
          <img src={LOGO} alt="Chop Box Co." className="w-10 h-10 md:w-12 md:h-12" />
          <div className="hidden sm:flex flex-col leading-none">
            <span className="font-display text-xl tracking-tighter text-[#1A6B2E]">CHOP BOX CO.</span>
            <span className="font-script text-sm text-[#D02030] mt-0.5">Small Chops. Big Flavour.</span>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-[#0E2B13]/70">
          <Link data-testid="nav-menu" to="/menu" className="hover:text-[#1A6B2E] transition-colors">Menu</Link>
          <a href="/#story" className="hover:text-[#1A6B2E] transition-colors">Our Story</a>
          <a href="/#contact" className="hover:text-[#1A6B2E] transition-colors">Contact</a>
          {user && (
            <Link data-testid="nav-orders" to="/orders" className="hover:text-[#1A6B2E] transition-colors">My Orders</Link>
          )}
          {user?.is_admin && (
            <Link data-testid="nav-admin" to="/admin/orders" className="hover:text-[#D02030] transition-colors font-semibold">Kitchen</Link>
          )}
        </nav>

        <div className="flex items-center gap-2 md:gap-3">
          {user ? (
            <div className="flex items-center gap-2">
              {user.picture ? (
                <img data-testid="user-avatar" src={user.picture} alt="" className="w-8 h-8 rounded-full border border-[#1A6B2E]/15" />
              ) : (
                <div className="w-8 h-8 rounded-full bg-[#E29A26]/25" />
              )}
              <button
                data-testid="logout-btn"
                onClick={async () => { await logout(); navigate("/"); }}
                className="p-2 text-[#0E2B13]/60 hover:text-[#D02030]"
                aria-label="Log out"
              >
                <LogOut className="w-4 h-4" />
              </button>
            </div>
          ) : (
            <Button
              data-testid="google-login-btn"
              onClick={login}
              variant="ghost"
              className="hidden sm:inline-flex rounded-full text-sm font-medium text-[#0E2B13] hover:bg-[#F4EFEB]"
            >
              Sign in with Google
            </Button>
          )}

          <button
            data-testid="cart-open-btn"
            onClick={() => setIsOpen(true)}
            className="relative rounded-full bg-[#1A6B2E] text-[#FDFBF7] pl-4 pr-5 py-2.5 flex items-center gap-2 hover:bg-[#135220] transition-colors"
          >
            <ShoppingBag className="w-4 h-4" />
            <span className="text-sm font-medium">Cart</span>
            {count > 0 && (
              <span data-testid="cart-count-badge" className="ml-1 rounded-full bg-[#D02030] text-white text-xs font-bold w-6 h-6 grid place-items-center">
                {count}
              </span>
            )}
          </button>
        </div>
      </div>
    </header>
  );
}
